import React, { Component, useState, useMemo, useEffect, useRef } from "react";
import { useParams } from 'react-router';
import { TextField, Typography, Slide, Button, Box, CircularProgress, Grid, Divider, Table, Autocomplete, DialogContent, Tooltip } from '@mui/material';
import { query, flattenObj, unflattenObject, TokenData } from '../App';
import InputColumn from './InputColumn'
import TabManager from "./TabsInput";
import AutocompleteText from "./AutocompleteText"
import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import { ChatBox, Message } from "./ChatBox";
import { productStatusToInfo } from "../pages/Orders";
import WZTrackingBundle from "./WZTrackingBundle";
const productInputs = [
    {
        type: AutocompleteText,
        props: {
            label: "Typ plikow", name: "files.type", required: true, disabled: true,
            options: [
                //{ label: "Pliki ok", value: "ok" },//TODO
                //{ label: "Pliki błędne", value: "wrong" },
                { label: "Pliki link", value: "link" },
                { label: "Pliki dysk sieciowy", value: "cloud" },
                { label: "Pliki inne", value: "other" },
                { label: "FTP", value: "ftp" },
                { label: "Brak plikow", value: "none" },
            ]
        }
    },
    { type: TextField, props: { label: "Link", name: "files.info", disabled: true, } },
]

export default function OrderManage(props) {
    const userPermissions = (React.useContext(TokenData)).permissions;
    const { orderId } = useParams();
    const [products, setProducts] = useState();
    const [dialogState, setDialogState] = useState({ open: false, text: undefined, handleAgree: undefined });
    const tabManager = useRef();
    const [productionEmployees, setProductionEmployees] = useState(props.productionEmployees ? props.productionEmployees.map(employee => ({ label: employee.name, value: employee.name })) : undefined);

    useEffect(() => {
        if (props.order) {
            setProducts(props.order.products.map(product => Object.assign(flattenObj(product), product)));
            query("/mysql/pracownicy", "GET").then(res => setProductionEmployees(res))
        }
    }, [props.order])

    const handleClose = () => {
        setDialogState({ ...dialogState, open: false })
    };

    async function changeStatusButtonHandler(product, status) {
        console.log(props.order);
        await query(`/orders/products/changeStatus/${status}/${props.order["_id"]}/${product.id}`, 'PATCH');
        window.location.reload();
    }

    function ProductStatusChangeButton(props) {
        const { product, newStatus, color, text, permissionClass } = props;
        let additionalPermission = userPermissions[permissionClass] ? userPermissions[permissionClass].edit : false;
        if ((product.status != newStatus) && (userPermissions.admin || additionalPermission))
            return (
                <Button variant="contained" sx={{
                    backgroundColor: color, '&:hover': {
                        backgroundColor: color,
                    }
                }} onClick={() => changeStatusButtonHandler(product, newStatus)}>{text}</Button>
            )
        else return;
    }

    return (
        !products ?
            <CircularProgress /> :
            <Grid xs={12} item>
                <TabManager ref={tabManager} title={"Wybór produku"}>
                    {
                        products.map((product, index) => <Grid xs={12} item container index={index} tablabel={`Produkt ${product.id}`} key={"filesTab." + index} >
                            <Grid xs={12} item>
                                <Typography variant="h5" textAlign="center" className="container" sx={{ marginBottom: "20px" }}>
                                    {product['product_name']}
                                </Typography>
                            </Grid>
                            {(userPermissions.admin || (userPermissions.warehouse && userPermissions.warehouse.edit)) && <Grid xs={12} item container>
                                <Grid xs={12} item container className="container" sx={{ marginBottom: "20px" }}>
                                    <Typography variant="h5" textAlign="left" sx={{
                                        padding: "20px"
                                    }}>
                                        <Grid sx={12} item container>Obecny status: &nbsp; {productStatusToInfo(product)}</Grid>
                                        Zmien status na:
                                        <Grid item sx={{
                                            "&>button": {
                                                marginLeft: "10px"
                                            }
                                        }}>
                                            <ProductStatusChangeButton product={product} newStatus={0} color={"orange"} text={"Pliki do sprawdzenia"} permissionClass={""} />
                                            <ProductStatusChangeButton product={product} newStatus={1} color={"green"} text={"Pliki poprawne"} permissionClass={""} />
                                            <ProductStatusChangeButton product={product} newStatus={2} color={"#d32f2f"} text={"Czeka na odpowiedz administratora"} permissionClass={""} />
                                            <ProductStatusChangeButton product={product} newStatus={3} color={"green"} text={"W realizacji"} permissionClass={""} />
                                            <ProductStatusChangeButton product={product} newStatus={4} color={"#1976d2"} text={"Gotowe"} permissionClass={"warehouse"} />
                                            <ProductStatusChangeButton product={product} newStatus={5} color={"#000000bf"} text={"Odebrane"} permissionClass={"warehouse"} />
                                        </Grid>
                                    </Typography>
                                </Grid>
                            </Grid>}
                            <Grid xs={12} item container spacing={3} sx={{ marginBottom: "20px" }}>
                                <Grid xs={4} item container>
                                    <Box sx={{ width: "100%" }} className="container">
                                        <InputColumn fields={productInputs} data={product} title={'Pliki'} xs={12} />
                                    </Box>
                                </Grid>
                                <Grid xs={8} item container>
                                    <Box sx={{ width: "100%" }} className="container">
                                        <Typography variant="h5" textAlign="center">
                                            Historia wiadomosci
                                        </Typography>
                                        <ChatBox style={{
                                            height: "300px",
                                            overflowX: "hidden"
                                        }}>
                                            {
                                                product["files.history"].map((historyRow, index) =>
                                                    <Message key={"messageId." + index}
                                                        by={historyRow.person}
                                                        time={historyRow.date}
                                                        side={index % 2 == 1 ? "right" : "left"}>
                                                        {historyRow.reason}
                                                    </Message>)
                                            }
                                        </ChatBox>
                                        <Grid xs={12} item container>
                                            <Grid xs={6} item container justifyContent={"center"}>

                                                {
                                                    product.status != 1 && <Grid xs={6} item container justifyContent={"center"}><Button variant="contained" color="success"
                                                        onClick={() => setDialogState({
                                                            open: true,
                                                            text: "Czy na pewno chcesz zatwierdzic pliki?",
                                                            handleAgree: async (reason) => {
                                                                await query(`/orders/${orderId}/product/${tabManager.current.getPage()}/files/accept`, "PATCH")
                                                                window.location.reload();
                                                            }
                                                        })}>Zatwierdz pliki</Button></Grid>
                                                }
                                            </Grid>

                                            <Grid xs={6} item container justifyContent={"center"}>
                                                {
                                                    product.status == 0 && <Button variant="contained" color="error"
                                                        onClick={() => setDialogState({
                                                            open: true,
                                                            text: "Podaj powod odrzucenia pliku",
                                                            textfieldPlaceholder: "Podaj powod odrzucenia",
                                                            handleAgree: async (reason) => {
                                                                await query(`/orders/${orderId}/product/${tabManager.current.getPage()}/files/reject`, "PATCH", {
                                                                    reason: reason
                                                                })
                                                                window.location.reload();
                                                            }
                                                        })}>
                                                        Odrzuc pliki</Button>
                                                }
                                                {
                                                    product.status == 2 && <Button variant="contained" color="error"
                                                        onClick={() => setDialogState({
                                                            open: true,
                                                            text: "Wyslij wiadomosc zwrotną",
                                                            textfieldPlaceholder: "Tekst wiadomosci zwrotnej",
                                                            handleAgree: async (reason) => {
                                                                await query(`/orders/${orderId}/product/${tabManager.current.getPage()}/files/check`, "PATCH", {
                                                                    reason: reason
                                                                })
                                                                window.location.reload();
                                                            }
                                                        })}>
                                                        Odpowiedz</Button>
                                                }

                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                            <WZTrackingBundle orderId={props.order._id} order={props.order} product={product} productionEmployees={productionEmployees} />
                        </Grid>)
                    }
                </TabManager >
                <Dialog
                    open={dialogState.open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogActions >
                        <form onSubmit={(e) => { e.preventDefault(); dialogState.handleAgree((new FormData(e.currentTarget)).get("rejectReason")); }}>
                            <Grid xs={12} item container sx={{
                                "&>*": {
                                    padding: "10px"
                                }
                            }}>
                                <DialogTitle id="alert-dialog-title" sx={{ padding: "10px" }}>
                                    {dialogState.text}
                                </DialogTitle>
                                {
                                    dialogState.textfieldPlaceholder && <Grid xs={12} item>
                                        <TextField
                                            name="rejectReason" multiline fullWidth rows={5} placeholder={dialogState.textfieldPlaceholder}
                                        />
                                    </Grid>
                                }
                                <Grid xs={6} item justifyContent={"center"} container>
                                    <Button variant="contained" onClick={handleClose} >Anuluj</Button>
                                </Grid>
                                <Grid xs={6} item justifyContent={"center"} container>
                                    <Button variant="contained" autoFocus type="submit">
                                        Zatwierdz
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogActions>
                </Dialog>
            </Grid >
    );
}